<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/11fRC9u/tc-custom/9781504065214.jpg?1737121986411" alt="This image is the cover for the book Chronicles of Barsetshire Volume Two, The Chronicles of Barsetshire"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Chronicles of Barsetshire Volume Two, The Chronicles of Barsetshire
      </h1>
      <p class="bookDescription body article font2">
        <b>Three wise, witty novels in the saga following the residents of a rural English town in the Victorian era.</b><br/><br/> In the nineteenth century, Anthony Trollope created the fictional world of Barsetshire, the setting for a series of classic novels that addressed love, murder, religion, politics, and the ordinary lives of locals both rich and poor.<br/><br/><i>Framley Parsonage</i>: A young vicar’s ambition drives him into a costly bargain in this comedic love story that brilliantly examines the intersection of romance and social class.<br/><br/><i>The Small House at Allington</i>: This witty novel follows the amorous misadventures of a pair of sisters.<br/><br/><i>The Last Chronicle of Barset</i>: A clergyman’s daughter falls in love with a member of high society, while her father stands accused of a terrible crime.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Anthony Trollope
      </h2>
      
      <p class="authorDescription body article">Anthony Trollope (1815&ndash;1882) was the author of over fifty books of fiction and nonfiction and is widely regarded as one of the preeminent English novelists of the Victorian era. Uncommon in his ability to capture both a wide readership and the highest respect of his most influential critics and peers&mdash;including luminaries such as Nathaniel Hawthorne, William Thackeray, Henry James, and George Eliot&mdash;Trollope is best remembered for two great sextets, the Chronicles of Barsetshire and the Pallisers, as well as his late-career satirical masterpiece <I>The Way We Live Now</I>.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?60c56802